/**
 * The one origin every absolute URL on the site is built from: canonicals, the sitemap,
 * robots.txt. It is www because the apex 308s there, and a sitemap or canonical that
 * points at a redirect contradicts the page it describes.
 */
export const SITE_ORIGIN = 'https://www.musiceternal.life';
